import * as Yup from 'yup';

import { toI18n } from 'util/i18n';

export const IMPORT_FROM_POS = 'import_from_pos';
export const MANUAL = 'manual';
export const DAILY = 'daily';
export const CALCULATION_FREQUENCIES = ['pay_period', 'daily'];
export const DRAWER_COMPONENTS_NAME = {
  EDIT_TIP_POOL_DRAWER: 'EDIT_TIP_POOL_DRAWER',
  CALCULATE_TIP_OUTS_DRAWER: 'CALCULATE_TIP_OUTS_DRAWER',
};

export const DEFAULT_IMPORT_FROM_POS = true;
export const DEFAULT_CALCULATION_METHOD = 'hours_worked';
export const DEFAULT_FREQUENCY = 'pay_period';
export const DEFAULT_DISTRIBUTION_TYPE = 'equally';

export const DISTRIBUTION_TYPES = {
  EQUALLY: 'equally',
  PERCENTAGE_BY_ROLE: 'percentage_by_role',
};

export const DEPARTMENT_NOT_SET = 'Dept. not set';

export const STEP_VALIDATION_SCHEMAS = {
  basicInfo: Yup.object().shape({
    tipPoolName: Yup.string()
      .required(
        toI18n(
          'tip_pooling_settings.tip_pool_drawer.form_errors.required_field'
        )
      )
      .max(
        40,
        toI18n(
          'tip_pooling_settings.tip_pool_drawer.form_errors.tip_pool_name_max_length'
        )
      ),
  }),

  calculation: Yup.object().shape({
    frequency: Yup.string()
      .required(
        toI18n(
          'tip_pooling_settings.tip_pool_drawer.form_errors.required_field'
        )
      )
      .oneOf(CALCULATION_FREQUENCIES),
    importFromPOS: Yup.string().required(),
    creditCardFeeEnabled: Yup.boolean().default(false),
    creditCardFeePercentage: Yup.number().when('creditCardFeeEnabled', {
      is: true,
      then: schema =>
        schema
          .required(
            toI18n(
              'tip_pooling_settings.tip_pool_drawer.form_errors.required_field'
            )
          )
          .min(
            0.001,
            toI18n(
              'tip_pooling_settings.tip_pool_drawer.form_errors.credit_card_fee_min'
            )
          )
          .max(
            100,
            toI18n(
              'tip_pooling_settings.tip_pool_drawer.form_errors.credit_card_fee_max'
            )
          ),
      otherwise: schema => schema.notRequired(),
    }),
  }),

  sources: Yup.object().shape({}),

  recipients: Yup.object().shape({
    recipients: Yup.string().oneOf(['all', 'selection']),
    selectedRoles: Yup.array().when('recipients', {
      is: 'selection',
      then: schema =>
        schema.min(
          1,
          toI18n(
            'tip_pooling_settings.tip_pool_drawer.form_errors.role_selection_required'
          )
        ),
      otherwise: schema => schema.notRequired(),
    }),
    distributionType: Yup.string().oneOf(Object.values(DISTRIBUTION_TYPES)),
    roleSplits: Yup.array().when('distributionType', {
      is: DISTRIBUTION_TYPES.PERCENTAGE_BY_ROLE,
      then: schema =>
        schema
          .min(
            2,
            toI18n(
              'tip_pooling_settings.tip_pool_drawer.form_errors.minimum_roles_required'
            )
          )
          .test(
            'total-100',
            toI18n(
              'tip_pooling_settings.tip_pool_drawer.form_errors.percentages_total_100'
            ),
            roleSplits => {
              if (!roleSplits || !roleSplits.length) return true;
              const total = roleSplits.reduce(
                (sum, role) => sum + parseFloat(role.percentage || 0),
                0
              );
              return Math.abs(total - 100) < 0.01;
            }
          )
          .test(
            'all-roles-selected',
            toI18n(
              'tip_pooling_settings.tip_pool_drawer.form_errors.all_roles_selected'
            ),
            roleSplits => {
              if (!roleSplits || !roleSplits.length) return true;
              return roleSplits.every(
                role => role.roleId && role.roleId !== ''
              );
            }
          )
          .test(
            'all-percentages-valid',
            toI18n(
              'tip_pooling_settings.tip_pool_drawer.form_errors.percentages_greater_than_zero'
            ),
            roleSplits => {
              if (!roleSplits || !roleSplits.length) return true;
              return roleSplits.every(role => {
                const percentage = parseFloat(role.percentage || 0);
                return !isNaN(percentage) && percentage > 0;
              });
            }
          ),
      otherwise: schema => schema.notRequired(),
    }),
  }),

  review: Yup.object().shape({}),
};

export const infoStepListData = [
  {
    primary: toI18n(
      `tip_pooling_settings.tip_pool_drawer.info_step.point_1.primary`
    ),
    secondary: toI18n(
      `tip_pooling_settings.tip_pool_drawer.info_step.point_1.secondary`
    ),
  },
  {
    primary: toI18n(
      `tip_pooling_settings.tip_pool_drawer.info_step.point_2.primary`
    ),
    secondary: toI18n(
      `tip_pooling_settings.tip_pool_drawer.info_step.point_2.secondary`
    ),
  },
  {
    primary: toI18n(
      `tip_pooling_settings.tip_pool_drawer.info_step.point_3.primary`
    ),
    secondary: toI18n(
      `tip_pooling_settings.tip_pool_drawer.info_step.point_3.secondary`
    ),
  },
];
